<template>
  <div class="club-container">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="基本信息" name="first">
        <el-form v-if="club" class="user-from" label-width="160px" >
          <el-form-item label="会员单位名称">
            <el-input v-model="club.name" />
          </el-form-item>
          <el-form-item class="label-line-height" label="会员单位Logo" >
            <el-upload
              :on-success="handleSuccess"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
              :show-file-list="false"
              :data="dataObj"
              :action="qiniuUp"
              :accept="accept"
              class="upload-size"
              list-type="picture-card">
              <el-popover
                placement="top-start"
                trigger="hover">
                <div class="popover-content"><img :src="club.profile | ImageFormats" alt="img"/></div>
                <img slot="reference" v-show="club.profile" :src="club.profile | ImageFormats" >
              </el-popover>
              <i v-show="!club.profile" class="el-icon-plus avatar-uploader-icon"/>
              <div slot="tip" class="el-upload__tip">只能上传图片，建议不超过5Mb</div>
            </el-upload>
            <a v-if="club.profile" style="font-size: 18px;" :href="club.profile | ImageFormats">查看原图</a>
            <el-dialog :visible.sync="dialogVisible">
              <img :src="dialogImageUrl" width="100%">
            </el-dialog>
          </el-form-item>
          <el-form-item label="资质证明">
            <el-upload
              :show-file-list="false"
              :data="dataObj"
              :action="qiniuUp"
              :accept="accept"
              :on-success="handleCertificateFront"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
              class="upload-demo">
              <el-popover
                placement="top-start"
                trigger="hover">
                <div class="popover-content"><img :src="club.certificateImg | ImageCertFormats" alt="img"/></div>
                <img slot="reference" v-show="club.certificateImg" :src="club.certificateImg | ImageCertFormats" class="certificate-upload-style" >
              </el-popover>
              <div v-show="!club.certificateImg" class="certificate-upload-style" >
                选择上传文件
              </div>
              <div slot="tip" class="el-upload__tip">注：请上传企业资质证明图片</div>
            </el-upload>
            <a v-if="club.certificateImg" style="font-size: 18px;" :href="club.certificateImg | ImageCertFormats">查看原图</a>
          </el-form-item>
          <!--<el-form-item label="曾经球队">-->
            <!--&lt;!&ndash;<el-input v-model="club.teams" />&ndash;&gt;-->
            <!--&lt;!&ndash;<el-input v-model="beforeTeam" class="team-info-width" />&ndash;&gt;-->
            <!--&lt;!&ndash;<el-button type="info" @click="addBeforTeam()" >添加</el-button>&ndash;&gt;-->
          <!--</el-form-item>-->
          <el-form-item label="俱乐部名称">
            <el-input
              v-model="club.teams"
              placeholder="多个球队以', '分隔"/>
          </el-form-item>
          <el-form-item label="成立时间" >
            <el-date-picker
              v-model="club.establishDate"
              type="date"
              placeholder="选择日期时间"/>
          </el-form-item>
          <el-form-item label="职工总数">
            <el-input
              v-model="club.humanCount"
              placeholder=""/>
          </el-form-item>
          <el-form-item label="资产总额（亿）">
            <el-input
              v-model="club.assertCount"
              placeholder=""/>
          </el-form-item>
          <el-form-item label="年度营业收入总额（亿）">
            <el-input
              v-model="club.inComeCount"
              placeholder=""/>
          </el-form-item>
          <el-form-item label="会员单位简介">
            <el-input
              :rows="2"
              v-model="club.remark"
              type="textarea"
              placeholder="请输入会员单位简介"/>
          </el-form-item>
          <el-form-item label="再次注册年度" >
            <el-input v-model="club.membershipYear" disabled />
            <el-dropdown trigger="click" placement="bottom">
              <span class="el-dropdown-link font-size-style">
                历史注册年度<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in historyYears" :key="item.year">{{ item.year }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
          <el-form-item label="请选择渠道">
            <el-select v-model="club.source" filterable placeholder="请选择" style="width: 300px">
              <el-option v-for="(item, index) in sourceList" :key="index" :label="item" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="请填写其他渠道" v-if="club.source==sourceList[3]">
            <el-input
              :rows="2"
              v-model="club.otherSource"
              type="textarea"
              placeholder="请输入"/>
          </el-form-item>
          <el-form-item>
            <el-button v-permission="['user-club-edit']" :loading="userLoding" type="primary" @click="setUserManage()" >保存</el-button>
            <!--<el-button type="info" plain>返回</el-button>-->
          </el-form-item>
        </el-form>

      </el-tab-pane>
      <el-tab-pane label="联系方式" name="second">
        <el-form v-if="club" label-width="96px" class="lce-hockey-level" >
          <el-form-item label="联系人">
            <el-input v-model="club.contact" />
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input v-model="club.mobile" />
          </el-form-item>
          <el-form-item label="邮箱">
            <el-input v-model="club.email" />
          </el-form-item>
          <el-form-item label="地址">
            <el-input v-model="club.address" />
          </el-form-item>
          <el-form-item>
            <el-button v-permission="['user-club-edit']" :loading="userLoding" type="primary" @click="setUserManage()" >保存</el-button>
            <!--<el-button type="info" plain>返回</el-button>-->
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import moment from 'moment'
import permission from '@/directive/permission/index.js' // 权限判断指令
import { getClubEdit, updateClubEdit } from '@/api/club'
import { varConfig, showMessage, ImageFormat, ConstConfig, getDateObjectByString } from '@/utils'
import { getQiniuUploadToken, getSourceList } from '@/api/site'
import { getHistoryMembershipYear } from '@/api/user'

export default {
  name: 'Details',
  directives: { permission },
  data() {
    return {
      beforeTeam: null,
      activeName: 'first',
      dialogImageUrl: '',
      dialogVisible: false,
      sex: null,
      dataObj: { token: '' },
      qiniuUp: varConfig.qiniuUp,
      accept: ConstConfig.accept,
      club: null,
      userLoding: false,
      historyYears: [],
      clubId: null,
      sourceList: []
    }
  },
  created() {
    this.clubId = this.$route.params.id
    this.getClubInfo()
    this.getQiniuToken()
    this.sourceList = getSourceList()
  },
  mounted() {},
  methods: {
    getClubInfo() {
      const params = { id: this.clubId }
      getClubEdit(params).then((resolve) => {
        const club = resolve.data
        if (club.source) {
          if (!this.sourceList.includes(club.source)) {
            club.otherSource = club.source
            club.source = this.sourceList[3]
          }
        }
      this.club = resolve.data

      this.club.establishDate = getDateObjectByString(this.club.establishDate)
        this.getHistoryMembershipYear(this.club.userId)
      }, (reject) => {
        console.log(reject)
      })
    },
    handleClick() {},
    setUserManage() {
      this.userLoding = true
      ////
      let params = {
        id: this.clubId,
        profile: this.club.profile,
        name: this.club.name,
        establishDate: this.club.establishDate ? moment(this.club.establishDate).format('YYYY-MM-DDTHH:mm:ss+0800'):'',
        certificateImg: this.club.certificateImg,
        contact: this.club.contact,
        mobile: this.club.mobile,
        address: this.club.address,
        remark: this.club.remark,
        email: this.club.email,
        teams: this.club.teams,
        humanCount: this.club.humanCount,
        assertCount: this.club.assertCount,
        inComeCount: this.club.inComeCount,

      }
      if (this.club.source === this.sourceList[3]) {
        params.source = this.club.otherSource
      } else {
        params.source = this.club.source
      }
      ///
      updateClubEdit(params).then((resolve) => {
        this.userLoding = false
        if (!resolve) {
          return
        }
        this.$message({
          message: '更新成功',
          type: 'success'
        })
      }, (reject) => {
        this.userLoding = false
        this.$message.error('数据保存失败')
      })
    },
    handleSuccess(response) {
      this.club.profile = response.hash
    },
    handleCertificateFront(response) {
      console.log(response)
      this.club.certificateImg = response.hash
    },
    handleError(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        showMessage('error', '上传头像图片大小不能超过 10MB!')
      }
      return isLt2M
    },
    getQiniuToken() {
      getQiniuUploadToken().then(response => {
        const data = response.data
        this.dataObj.token = data.token
      }).catch(err => {
        console.log(err, 'error', '七牛Token获取失败')
      })
    },
    getHistoryMembershipYear(userId) {
      getHistoryMembershipYear(userId, 0).then(response => {
        const data = response.data
        this.historyYears = data.list
      }).catch(err => {
      })
    },
    addBeforTeam() {
      this.club.teams += this.beforeTeam + '、'
    }
  },
  filters: {
    ImageFormats(img) {
      return ImageFormat.squareImageView(img, 1600, 2)
    },
    ImageCertFormats(img) {
      return ImageFormat.imageView(img, 1600, 641, 2)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  .club-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }

    .upload-size .el-upload {
      width: 80px;
      height: 80px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 78px;
      height: 78px;
      line-height: 78px !important;
      text-align: center;
      position: absolute;
      top: 0;
      left: 0;
    }

    .upload-size .el-upload:hover {
      border-color: #409EFF;
    }

    .upload-size .el-upload-list li {
      width: 80px;
      height: 80px;
    }

    .user-from .el-form-item__label {
      text-align: left;
      padding-left: 15px;
    }

    .certificate-upload-style {
      width: 120px;
      height: 32px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      color: #999999;
      line-height: 32px;
    }

    .font-size-style {
      font-size: 14px;
      color: #169BD5;
      padding-left: 20px;
    }

    .team-info-width {
      width: auto;
      margin-right: 12px;
    }

    .el-upload img {
      width: 78px;
      height: 78px;
    }

    .el-input--small {
      max-width: 300px;
    }

    .el-dropdown {
      cursor: pointer;
    }
  }

  .el-popover .popover-content img {
    max-width: 960px;
  }
</style>
